import cx from "classnames";

import EditableItemGroup from "../../../Blocks/Utils/EditableItemGroup/EditableItemGroup";
import { DragItem } from "../../../Blocks/Composites/DragAndDrop/DragItem";
import { GetWSMgr } from "@/Utils/StateLib";
import { OverflowText } from "@theorgchartdev/storybook";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { appstr } from "@coreapp/utils/appstr";
import { QParkingPanel } from "@coreapp/CoreApp/QParkingPanel";
import { QParkingElement } from "@coreapp/CoreApp/QParkingElement";
import { EventToCanvas } from "@coreapp/utils/EventToCanvas";
import { handleMouseEnter } from "@coreapp/utils/handleMouseEnter";
import { QChartBox } from "@coreapp/CoreApp/QChartBox";

export const StagingBranch = props => {
  const { canAccessProfileCard, canAccessRecordDetails } = usePermissionCheck();

  const recordId = props.branch.GetObjectRecordID();
  const numChildren = props.branch.GetNumChildren();

  const isHighlighted = props.manager.stagingState.highlightedRecordIds.includes(recordId);

  const handleDrillDown = () => {
    props.manager.drillDown(props.branch);
  };

  const handleDragStart = e => {
    const wsMgr = GetWSMgr();

    const canvasPanel = wsMgr.fCanvasPanel;
    canvasPanel.fDragSource = null;

    const canvas = wsMgr?.fCanvas;
    const rect = canvas.getBoundingClientRect();
    const { x, y } = EventToCanvas(e, rect.left, rect.top);

    const sourcePanel = new QParkingPanel();
    sourcePanel.InitializePanel(wsMgr);

    const sourceElement = new QParkingElement();
    sourceElement.InitParkingElement(props.branch, sourcePanel);
    sourceElement.StartInteractWithElement();
    sourceElement.SizeElement(0, 0);
    sourceElement.PositionElement(0, 0);

    const dragPanel = sourcePanel.InitializeDragPanel(
      wsMgr,
      sourceElement,
      x,
      y,
      wsMgr.ShiftDown()
    );

    wsMgr.PushPanel(dragPanel);
    dragPanel.fDraggerPanel = dragPanel;
    wsMgr.SetActiveDragPanel(dragPanel);
    const dimensions = { width: sourceElement.GetWidth(), height: sourceElement.GetHeight() };
    const sourceLayout = sourceElement instanceof QChartBox ? sourceElement?.GetLayout() : null;
    const boxShape = sourceLayout ? sourceLayout.GetBoxShapeType() : null;

    wsMgr.BroadcastTopic("dragStart", {
      panel: dragPanel,
      event: e,
      dimensions: dimensions,
      boxShape: boxShape
    });

    handleMouseEnter(canvas)(e);
  };

  const handleOpenProfile = () => {
    const wsMgr = GetWSMgr();
    wsMgr.ShowProfile(null, props.branch);
  };

  const handleOpenRecordDetails = () => {
    const wsMgr = GetWSMgr();
    wsMgr.ShowRecordInfo(null, props.branch);
  };

  const buildActions = () => {
    const dataTestIdPrefix = `staging-branch-${props.branch.SmartGetFieldValue("Name")}--`;
    const actions = [];
    if (canAccessProfileCard) {
      actions.push({
        dataTestId: `${dataTestIdPrefix}profile`,
        iconName: "address-card",
        onClick: handleOpenProfile,
        tooltipProps: {
          message: appstr("Profile")
        }
      });
    }

    if (canAccessRecordDetails) {
      actions.push({
        dataTestId: `${dataTestIdPrefix}record-details`,
        iconName: "circle-info",
        onClick: handleOpenRecordDetails,
        tooltipProps: {
          message: appstr("Record details")
        }
      });
    }

    if (numChildren > 0) {
      actions.push({
        dataTestId: `${dataTestIdPrefix}drill-down`,
        iconName: "caret-right",
        onClick: handleDrillDown
      });
    }

    return actions;
  };

  return (
    <DragItem
      onDragStart={handleDragStart}
      onMouseEnter={props.manager.handleMouseEnterNode(props.branch)}
    >
      <EditableItemGroup
        customClass={cx("oc-staging-branch", {
          "oc-staging-branch--highlighted": isHighlighted
        })}
        spaceBetween
        actions={buildActions()}
      >
        <div className="oc-overflow-hidden">
          <OverflowText className="oc-block oc-fill-width">
            {props.branch.FormatEmployeeLabel()}
          </OverflowText>
        </div>
      </EditableItemGroup>
    </DragItem>
  );
};
